
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnectionNoGoogle as ObiConnectionNoGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connection-no-google.js';
 
 
 

 
 export const ObiConnectionNoGoogle = createComponent({
   react: React,
   tagName: 'obi-connection-no-google',
   elementClass: ObiConnectionNoGoogleElement,
   events: {
     
   }
  });
 
 